<div class="card-container">
  <div class="content p-3">
    <!-- <div class="content-header-note"> -->
    <div class="message-card">
      <mwp-text-translate text="If any, please choose which other benefits you would like to apply your beneficiaries to." jsonKey="beneficiariesUpdateNote" />
    </div>
    <div class="message-container red-fill text-centered">
      <mwp-text-translate text="WARNING: THIS WILL DELETE THE BENEFICIARIES LISTED IN YOUR SELECTED BENEFITS AND REPLACE THEM WITH THE BENEFICARIES LISTED IN THE PREVIOUS SCREEN." jsonKey="beneficiariesUpdateWarning" />
    </div>
  </div>
  <form [formGroup]="beneficiariesForm">
    <div [formArrayName]="beneficiaryListArrayName">
      <table>
        <thead>
          <tr class="modal-tr">
            <th class="center-text p-3" style="width: 6%;">
              <mwp-text-translate text="Include" jsonKey="include" />
            </th>
            <th class="p-3">
              <mwp-text-translate text="Benefit" jsonKey="benefit" />
            </th>
          </tr>
        </thead>
        <tbody>
          @for (item of gridArrayControls; track item; let i = $index) {
            <tr class="has-controls modal-tr" [formGroupName]="i">
              <td class=" center-control">
                <mat-checkbox formControlName="isSelected" (change)="selectedGrid($event, i)"></mat-checkbox>
              </td>
              <td>
                <mat-form-field appearance="outline">
                  <input matInput formControlName="benefit">
                </mat-form-field>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </form>
  <div class="d-inline-flex justify-content-end w-100">
    <button class="mwp-button-secondary m-3" (click)="cancelForm()">
      <mwp-text-translate text="Cancel" jsonKey="cancel" />
    </button>
    <button class=" mwp-button-save m-3" (click)="completeForm()">
      <mwp-text-translate text={{saveButtonText}} jsonKey={{saveButtonText}} />
    </button>
  </div>
</div>